import { render, staticRenderFns } from "./email-unverified-page.vue?vue&type=template&id=097899b3&scoped=true&"
import script from "./email-unverified-page.vue?vue&type=script&lang=js&"
export * from "./email-unverified-page.vue?vue&type=script&lang=js&"
import style0 from "./email-unverified-page.vue?vue&type=style&index=0&id=097899b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097899b3",
  null
  
)

export default component.exports